// font style: normal, italic
// font weight: number 100-900 or bold, light, etc.
const callAddFont = (that, font, name, style = "normal", weight = "normal") => {
  try {
    that.addFileToVFS(`font-${name}.ttf`, font);
    that.addFont(`font-${name}.ttf`, name, style, weight);
  } catch (e) {
    console.log("error adding font", e);
  }
};

export const preparedAddingFonts = (fonts) =>
  function () {
    callAddFont(this, fonts.Oswald, "Oswald");
    callAddFont(this, fonts.OswaldBold, "Oswald", "normal", "bold");

    callAddFont(this, fonts.Caveat, "Caveat");
    callAddFont(this, fonts.CaveatBold, "Caveat", "normal", "bold");

    callAddFont(this, fonts.DMMono, "DM Mono");
    callAddFont(this, fonts.DMMonoItalic, "DM Mono", "italic");
    callAddFont(this, fonts.DMMonoMedium, "DM Mono", "normal", "bold");
    callAddFont(this, fonts.DMMonoMediumItalic, "DM Mono", "italic", "bold");

    callAddFont(this, fonts.Lora, "Lora");
    callAddFont(this, fonts.LoraBold, "Lora", "normal", "bold");
    callAddFont(this, fonts.LoraItalic, "Lora", "italic");
    callAddFont(this, fonts.LoraBoldItalic, "Lora", "italic", "bold");

    callAddFont(this, fonts.OpenSans, "Open Sans");
    callAddFont(this, fonts.OpenSansBold, "Open Sans", "normal", "bold");
    callAddFont(this, fonts.OpenSansItalic, "Open Sans", "italic");
    callAddFont(this, fonts.OpenSansBoldItalic, "Open Sans", "italic", "bold");

    callAddFont(this, fonts.PlayfairDisplay, "Playfair Display");
    callAddFont(this, fonts.PlayfairDisplayBold, "Playfair Display", "normal", "bold");
    callAddFont(this, fonts.PlayfairDisplayItalic, "Playfair Display", "italic");
    callAddFont(this, fonts.PlayfairDisplayItalicBold, "Playfair Display", "italic", "bold");

    callAddFont(this, fonts.Poppins, "Poppins");
    callAddFont(this, fonts.PoppinsItalic, "Poppins", "italic");
    callAddFont(this, fonts.PoppinsBold, "Poppins", "normal", "bold");
    callAddFont(this, fonts.PoppinsBoldItalic, "Poppins", "italic", "bold");

    callAddFont(this, fonts.Ubuntu, "Ubuntu");
    callAddFont(this, fonts.UbuntuBold, "Ubuntu", "normal", "bold");
    callAddFont(this, fonts.UbuntuItalic, "Ubuntu", "italic");
    callAddFont(this, fonts.UbuntuBoldItalic, "Ubuntu", "italic", "bold");
  };
